import React, { useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { AppContext } from "../../context/AppContext";
import { PDFExport } from "@progress/kendo-react-pdf";
import { Modal } from "react-bootstrap";
import close_modal from "../../assets/images/close_modal.svg";
import { displayDateFormat } from "../../common";
import BootstrapSpinner from "../../sharedComponent/BootstrapSpinner";
import { ToWords } from "to-words";
import close_modal_dark from "../../assets/images/close_modal_dark.svg";

const ServiceinvoiceView = ({
  previewTaxInvoiceData,
  previewLoader,
  isView,
  setIsView,
}) => {
  const { company_details, Dark, appSettings, units } = useContext(AppContext);
  var commaNumber = require("comma-number");
  const toWords = new ToWords();
  const amountInWords = toWords.convert(
    previewTaxInvoiceData.totalAmount ? previewTaxInvoiceData.totalAmount : 0,
    {
      currency: true,
    }
  );
  const container = React.useRef(null);
  const pdfExportComponent = React.useRef(null);

  const [discountVal, setDiscountVal] = useState(JSON.parse(localStorage.getItem("appSettings")) || {});
  useEffect(() => {
    const storedValue = JSON.parse(localStorage.getItem("appSettings"));
    if (storedValue) {
      setDiscountVal(storedValue);
    }
  }, []);

  const isStateSame =
    previewTaxInvoiceData?.compGstNo?.substring(0, 2) ===
      previewTaxInvoiceData?.placeOfSupply?.split("-")[1]
      ? true
      : previewTaxInvoiceData?.placeOfSupply === ""
        ? true
        : false;

  return (
    <div>
      <Modal
        style={{ zIndex: "2200" }}
        className="purchase-view-modal"
        size="lg"
        show={isView}
        onHide={() => setIsView(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Body>
          <div className="btnCloseRper">
            <div>
              <Link
                to="#"
                className="text-white"
                onClick={() => {
                  setIsView(false);
                  // setHideCopy(false);
                  // setJpegCheck(false);
                  // setpdfCheck(false);
                  // setPrintButton(false);
                }}
              >
                {Dark === "lightMode" ? (
                  <img
                    src={close_modal}
                    alt=""
                    // onClick={() => setPrint(false)}
                    style={{ cursor: "pointer" }}
                  />
                ) : (
                  <img
                    src={close_modal_dark}
                    alt=""
                    // onClick={() => setPrint(false)}
                    style={{ cursor: "pointer" }}
                  />
                )}
              </Link>
            </div>
            <div style={{ display: "flex" }}>
              {/* {printButton && (
                <div style={{ marginRight: "15px" }}>
                  <Link
                    className="salesCopyBtn text-white rpsCopyBtn"
                    onClick={() => {
                      setPrint(true);
                      setIsView(false);
                    }}
                  >
                    Print
                  </Link>
                </div>
              )} */}

              {/* {hideCopy == false ? (
                          <div>
                            <Link
                              to="#"
                              className="salesCopyBtn text-white rpsCopyBtn"
                              onClick={() => {
                                setIsView(false);
                                getCopyTaxInvoiceData(previewTaxInvoiceData.id);
                              }}
                            >
                              Copy
                            </Link>
                          </div>
                        ) : (
                          ""
                        )} */}

              {/* {jpegCheck && (
                          <div>
                            <Link
                              to="#"
                              onClick={() => {
                                exportComponentAsJPEG(container);
                              }}
                              className="salesCopyBtn text-white rpsCopyBtn"
                            >
                              JPEG
                            </Link>
                          </div>
                        )} */}
              {/* {pdfCheck && (
                          <div>
                            <Link
                              to="#"
                              onClick={exportPDFWithComponent}
                              className="salesCopyBtn text-white rpsCopyBtn"
                            >
                              PDF
                            </Link>
                          </div>
                        )} */}
            </div>
          </div>
          <PDFExport
            ref={pdfExportComponent}
            paperSize="auto"
            margin={40}
            fileName={`Report for ${new Date().getFullYear()}`}
            author="KendoReact Team"
          >
            {previewLoader ? (
              <div style={{ margin: "50%" }}>
                <BootstrapSpinner />
              </div>
            ) : (
              <div ref={container} className="main-invoice-card">
                <div className="invoice-inner-main">
                  <div className="text-invoice-main">
                    <div className="text-invoice-inner">
                      <div className="left">
                        <div className="text-invoice-heading">
                          {/* <label htmlFor="">Tax Invoice</label> */}
                        </div>
                        <div className="invoice-date-number">
                          <label htmlFor="">
                            {previewTaxInvoiceData.invoiceNo}
                          </label>
                          <label htmlFor="">
                            Date:{" "}
                            <span>
                              {displayDateFormat(
                                appSettings.dateFormat,
                                previewTaxInvoiceData.invoiceDate
                              )}
                            </span>
                          </label>
                          <label htmlFor="">
                            Due Date:
                            <span>
                              {displayDateFormat(
                                appSettings.dateFormat,
                                previewTaxInvoiceData.dueDate
                              )}
                            </span>
                          </label>
                        </div>
                      </div>
                      {/* <div className="right">
                                <img src={Logo} alt="" />
                              </div> */}
                    </div>
                  </div>
                  <div className="name-details-main">
                    <div className="name-details-inner row">
                      <div className="col-lg-7 left p-0">
                        <div className="name">
                          <label htmlFor="">
                            {previewTaxInvoiceData.compName}
                          </label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>
                        </div>
                        <div className="address">
                          <div>
                            <label htmlFor="" id="address">
                              {previewTaxInvoiceData.compAddr}
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="contact">
                              Email Id:
                              <span> {previewTaxInvoiceData.compEmail}</span>
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="contact">
                              Contact No:
                              <span> {previewTaxInvoiceData.compContact}</span>
                            </label>
                          </div>
                          {appSettings && appSettings.isGSTApplicable && (
                            <div>
                              <label htmlFor="" className="gst-no">
                                GST No. :{" "}
                                <span> {previewTaxInvoiceData.compGstNo}</span>
                              </label>
                            </div>)}
                          <div>
                            <label htmlFor="" className="pan-no">
                              PAN No. :{" "}
                              <span>{previewTaxInvoiceData.compPanNo}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 right p-0">
                        <div className="place-heading">
                          <label htmlFor="">Place of Supply:</label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>
                        </div>
                        <div className="place">
                          <label htmlFor="">
                            {previewTaxInvoiceData.placeOfSupply}
                          </label>
                        </div>
                        <div className="place-heading">
                          <label htmlFor="">Mode of Payment:</label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>
                        </div>
                        <div className="place">
                          <label htmlFor="">
                            {previewTaxInvoiceData.modeOfPay}
                          </label>{" "}
                          <br />
                          <label htmlFor="">
                            Cheque No.{" "}
                            <span>{previewTaxInvoiceData.chequeNo}</span>
                          </label>
                          <br />
                          <label htmlFor="">
                            {previewTaxInvoiceData.bankName}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="name-details-main" id="info">
                    <div className="name-details-inner row">
                      <div className="col-lg-7 left p-0">
                        <div className="name">
                          <label htmlFor="" id="small-heading">
                            Bill To,
                          </label>
                          <Link to="#">
                            {/* <img src={ic_green_pen} alt="" /> */}
                          </Link>{" "}
                          <br />
                        </div>
                        <div className="address">
                          <div>
                            <label htmlFor="">
                              {previewTaxInvoiceData.suppName}
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" id="address">
                              {previewTaxInvoiceData.suppAddr}
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="contact">
                              Email Id :
                              <span> {previewTaxInvoiceData.suppEmail}</span>
                            </label>
                          </div>
                          <div>
                            <label htmlFor="" className="contact">
                              Contact No:
                              <span> {previewTaxInvoiceData.suppContact}</span>
                            </label>
                          </div>
                          {appSettings && appSettings.isGSTApplicable && (
                            <div>
                              <label htmlFor="" className="gst-no">
                                GST:{" "}
                                <span>{previewTaxInvoiceData.suppGstNo} </span>
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {/* Ship to */}
                      {previewTaxInvoiceData.shipName ? (
                        <div className="col-lg-5 right p-0">
                          <div className="name">
                            <label htmlFor="" id="small-heading">
                              Ship To,{" "}
                            </label>
                            <br />
                          </div>
                          <div className="address">
                            <div>
                              <label htmlFor="">
                                {previewTaxInvoiceData.shipName}
                              </label>
                            </div>
                            <div>
                              <label htmlFor="" id="address">
                                {previewTaxInvoiceData.shipAddr}
                              </label>
                            </div>
                            <div>
                              <label htmlFor="" className="contact">
                                Contact No:
                                <span>
                                  {" "}
                                  {previewTaxInvoiceData.shipContact}
                                </span>
                              </label>
                            </div>
                            {appSettings && appSettings.isGSTApplicable && (
                              <div>
                                <label htmlFor="" className="gst-no">
                                  GST:{" "}
                                  <span>{previewTaxInvoiceData.shipGstNo} </span>
                                </label>
                              </div>)}
                          </div>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="detail-table-main" id="modal-in-tab">
                    <table>
                      <thead>
                        <tr className="heading-row">
                          <td>#</td>
                          <td>Product Name/Service Name</td>
                          <td>HSN/SAC</td>
                          <td>Quantity</td>
                          <td>Rate</td>
                          <td>Unit</td>
                          <td>Disc. <span>{discountVal.discType === "Amount" ? `(₹)` : `(%)`}</span></td>
                          <td>Amount</td>
                          {appSettings && appSettings.isGSTApplicable && (
                            isStateSame) ? (
                            <>
                              <td colSpan="2">CGST</td>
                              <td colSpan="2">SGST</td>
                            </>
                          ) : (
                            <>
                              {appSettings && appSettings.isGSTApplicable && (
                                <td colSpan="2">IGST</td>)}
                            </>
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        {previewTaxInvoiceData.purchInvDetails?.length > 0 &&
                          previewTaxInvoiceData.purchInvDetails.map(
                            (invDetails, index) => {
                              let unit =
                                units &&
                                units.filter((item) => {
                                  return item.id === invDetails.unitId;
                                })[0]?.unit;
                              return (
                                <tr key={invDetails.id}>
                                  <td>{1 + index}</td>
                                  <td>{invDetails.productName}</td>
                                  <td>{invDetails.hsnCode}</td>
                                  <td>{invDetails.qty}</td>
                                  <td>{invDetails.rate}</td>
                                  <td>{invDetails.unit}</td>
                                  <td>
                                    {invDetails.discPer}{" "}
                                    {appSettings?.discType === "Amount"
                                      ? ""
                                      : "%"}
                                  </td>
                                  <td>{invDetails.discAmount}</td>
                                  {appSettings && appSettings.isGSTApplicable && (
                                    isStateSame) ? (
                                    <>
                                      <td>{invDetails.cgst}%</td>
                                      <td>{invDetails.cgstAmount}</td>
                                      <td>{invDetails.sgst}%</td>
                                      <td>{invDetails.sgstAmount}</td>
                                    </>
                                  ) : (

                                    <>
                                      {appSettings && appSettings.isGSTApplicable && (
                                        <td>{invDetails.igst}%</td>)}
                                      {appSettings && appSettings.isGSTApplicable && (
                                        <td>{invDetails.igstAmount}</td>)}
                                    </>
                                  )}
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>
                  </div>

                  <div className="sub-total-section">
                    <div className="bank-details">
                      {previewTaxInvoiceData?.bankDetails && (
                        <label htmlFor="">Bank Details :</label>
                      )}
                      {previewTaxInvoiceData?.bankDetails &&
                        previewTaxInvoiceData?.bankDetails
                          .split("\r\n")
                          .map((str, i) => {
                            return (
                              <div key={i + "bankDetails"} className="bank-sub">
                                <label htmlFor="">{str && str}</label>
                              </div>
                            );
                          })}
                    </div>
                    <div className="right-section">
                      <div className="left">
                        <div className="text-sub">
                          <label htmlFor="">Sub Total</label>
                        </div>
                        {appSettings && appSettings.isGSTApplicable && (
                          isStateSame) ? (
                          <>
                            <div className="text-sub">
                              <label htmlFor="">CGST</label>
                            </div>
                            <div className="text-sub">
                              <label htmlFor="">SGST</label>
                            </div>
                          </>
                        ) : (
                          <>
                            {appSettings && appSettings.isGSTApplicable && (
                              <div className="text-sub">
                                <label htmlFor="">IGST</label>
                              </div>)}
                          </>
                        )}
                        {appSettings && appSettings.isRoundOff && (
                          <div className="text-sub">
                            <label htmlFor="">Round off</label>
                          </div>
                        )}
                      </div>
                      <div className="right">
                        <div className="sub-total">
                          <label htmlFor="">
                            Rs. {previewTaxInvoiceData.subTotal}
                          </label>
                        </div>
                        {appSettings && appSettings.isGSTApplicable && (
                          isStateSame) ? (
                          <>
                            <div className="sub-total">
                              <label htmlFor="">
                                Rs.{" "}
                                {previewTaxInvoiceData?.cgstAmount?.toFixed(2)}
                              </label>
                            </div>
                            <div className="sub-total">
                              <label htmlFor="">
                                Rs.{" "}
                                {previewTaxInvoiceData.sgstAmount?.toFixed(2)}
                              </label>
                            </div>
                          </>
                        ) : (
                          <>
                            {appSettings && appSettings.isGSTApplicable && (
                              <div className="sub-total">
                                <label htmlFor="">
                                  Rs. {previewTaxInvoiceData.igstAmount?.toFixed(2)}
                                </label>
                              </div>)}
                          </>
                        )}
                        {appSettings && appSettings.isRoundOff && (
                          <div className="sub-total">
                            <label htmlFor="">
                              Rs.{" "}
                              {previewTaxInvoiceData.roundOff?.toFixed(2) ||
                                "0.00"}
                            </label>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mainsub-total"></div>
                  <div className="total-amt-main">
                    <div
                      className="total-amount-section"
                      id="sub-total-section"
                    >
                      <div className="left">
                        <div className="text-sub">
                          <label htmlFor="">Total Amount</label>
                        </div>
                      </div>
                      <div className="right">
                        <div className="sub-total">
                          <label htmlFor="">
                            Rs.{" "}
                            {commaNumber(
                              Math.round(
                                previewTaxInvoiceData.totalAmount
                              )?.toFixed(2)
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="in-word">
                      <label htmlFor="">{amountInWords}</label>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </PDFExport>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ServiceinvoiceView;
